import React from 'react';

import { LinkMainData, MainData, SubData } from './styled';
import { map } from '../../../../../util/lodashlike';
import CopyableValue from '../../../../common/components/CopyableValue';

/**
 * One CopyableValue PER LINE (FIN-14012): each line reveals its own full value in
 * a small, selectable tooltip anchored below the text it belongs to, so the user
 * can copy the id / names an ellipsis cuts off. No native `title` alongside it —
 * that would pop a second, uncopyable tooltip.
 *
 * Empty and '-' lines get no tooltip; CopyableValue handles that rule.
 */
/* `perLine = false` leaves the lines BARE, for a cell whose tooltip is attached
   once around the whole cell instead (see `combined` in index.js). Wrapping both
   would nest one tooltip inside another and fire two on hover. */
export const generateDatas = (data = [], perLine = true) =>
  map(data, (item, idx) => {
    const Line = idx > 0 ? SubData : MainData;
    const line = <Line>{item.text}</Line>;
    const key = idx > 0 ? `sub_data_${idx}` : `main_data_${idx}`;
    return perLine ? (
      <CopyableValue key={key} value={item.text}>
        {line}
      </CopyableValue>
    ) : (
      <React.Fragment key={key}>{line}</React.Fragment>
    );
  });

/* `perLine = false` as above — the cell-level Popover carries the values
   instead, so the lines must not each wrap one of their own. */
export const generateLinkDatas = (data = [], perLine = true) =>
  map(data, (item, idx) => {
    const { text, ...reset } = item;
    const key = idx > 0 ? `sub_link_data_${idx}` : `link_data_${idx}`;
    const line =
      idx > 0 ? (
        <SubData>{text}</SubData>
      ) : (
        <LinkMainData {...reset}>{text}</LinkMainData>
      );
    return perLine ? (
      <CopyableValue key={key} value={text}>
        {line}
      </CopyableValue>
    ) : (
      <React.Fragment key={key}>{line}</React.Fragment>
    );
  });

/* Lines with something to reveal. A missing value renders '-' in the TABLE —
   a placeholder, not a value — and repeating it in the card shows nothing. */
export const revealable = (data = []) =>
  data.filter((d) => {
    const t = typeof d.text === 'string' ? d.text.trim() : d.text;
    return t !== undefined && t !== null && t !== '' && t !== '-';
  });
